const state = {
  server: {},
  defaultServer: {},
  activeInputName: {}
}
export default state
